export enum TransferRequestType {
  'Default' = 'Default',
  'Voicemail' = 'Voicemail',
}
